import { Directive, Input } from '@angular/core';
import { IBaseComponent } from '../component/IBaseComponent';
import { DxPivotGridComponent } from 'devextreme-angular/ui/pivot-grid';

@Directive({ selector: '[configPivotGrid]' })
export class M4UConfigPivotGridDirective {
    constructor(private pivotGrid: DxPivotGridComponent) {
    }

    @Input() set Component(value: IBaseComponent) {        
        this.Init(value);
    }

    protected Init(component: IBaseComponent) {
        if (component == undefined || this.pivotGrid == undefined) return;
        
        const stateStoring = this.pivotGrid.stateStoring;
        this.pivotGrid.stateStoring = {
            storageKey:
                stateStoring?.storageKey || `${component.ComponentStateName}.PivotGrid.State`
        };
    }
}